import {
  apiClient,
  type PageEntity,
  type TruckTypeImportJobExEntity
} from '@/libs/api'
import { type TruckTypeImportJobsRequestQuery } from '@/libs/api/types'

export type FetchTruckTypeImportJobsQuery = {
  tenantKey: string
  query: TruckTypeImportJobsRequestQuery
}

export type FetchTruckTypeImportJobsResponse = {
  data: TruckTypeImportJobExEntity[]
  pagination: PageEntity | null
}

export const fetchTruckTypeImportJobs = async (
  { tenantKey, query }: FetchTruckTypeImportJobsQuery,
  signal?: AbortSignal
): Promise<FetchTruckTypeImportJobsResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .truck_type_import_jobs.$get({
      query,
      config: {
        signal
      }
    })
  return {
    data,
    pagination
  }
}
